import React, { useEffect, useState } from "react"
import {
  Button,
  Col,
  FormGroup,
  Label,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Table,
} from "reactstrap"
import Select from "react-select"
import { useDispatch } from "react-redux"
import { useSelector } from "react-redux"
import { getAllBranchs } from "store/actions/usersAction"
import { Field, Formik, Form, ErrorMessage } from "lib/formik"
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import Switch from "components/Shared/Switch"
import { updateOpeningHoursSchema } from "components/Common/validation"
import { updateMultiplesBranch } from "store/actions/branchsActions"
import { showAlert } from "store/reducers/alertReducer"
import { allOption } from "components/Common/constants"
import TextError from "components/Shared/TextError"

const initialValues = {
  ids: [],
  // status: true,
  openingHours: [
    {
      dayOfWeek: "Monday",
      openingTime: "00:00",
      closingTime: "23:59",
      closed: false,
    },
    {
      dayOfWeek: "Tuesday",
      openingTime: "00:00",
      closingTime: "23:59",
      closed: false,
    },
    {
      dayOfWeek: "Wednesday",
      openingTime: "00:00",
      closingTime: "23:59",
      closed: false,
    },
    {
      dayOfWeek: "Thursday",
      openingTime: "00:00",
      closingTime: "23:59",
      closed: false,
    },
    {
      dayOfWeek: "Friday",
      openingTime: "00:00",
      closingTime: "23:59",
      closed: false,
    },
    {
      dayOfWeek: "Saturday",
      openingTime: "00:00",
      closingTime: "23:59",
      closed: false,
    },
    {
      dayOfWeek: "Sunday",
      openingTime: "00:00",
      closingTime: "23:59",
      closed: false,
    },
  ],
}

const UpdateOpeningHours = ({ toggle, t, language }) => {
  const dispatch = useDispatch()

  const { isLoading, branchsList } = useSelector(state => state.Users)
  const [isAllSelected, setIsAllSelected] = useState(false)

  const [closedDays, setClosedDays] = useState(
    initialValues.openingHours.map(hour => hour.closed)
  )

  useEffect(() => {
    fetchAllBranches()
  }, [])

  const fetchAllBranches = () => {
    dispatch(getAllBranchs())
  }

  const handleOnSubmit = (values, { resetForm }) => {
    const { ids, status, openingHours } = values
    const updatedIds = ids.map(item => item.value)
    // const updatedStatus = status ? "1" : "0"
    const payload = {
      ids: updatedIds,
      openingHours,
    }
    dispatch(updateMultiplesBranch(payload))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          dispatch(showAlert({ text: msg, type: "success" }))
          toggle()
        } else {
          dispatch(showAlert({ text: msg, type: "error" }))
        }
      })
      .catch(error => {})
  }

  const branchListOptions = branchsList?.map(item => ({
    label: language === "sa" ? item.nameAr : item.name,
    value: item._id,
  }))

  const options = isAllSelected
    ? branchListOptions
    : [allOption, ...branchListOptions]

  return (
    <>
      <ModalHeader toggle={toggle}>
        {t("Update multiples opening hours")}
      </ModalHeader>
      <ModalBody>
        <Formik
          initialValues={initialValues}
          validationSchema={updateOpeningHoursSchema}
          onSubmit={handleOnSubmit}
        >
          {({ values, setFieldValue, errors, touched }) => (
            <Form>
              <Row className="mb-4">
                <Col md={12}>
                  <div className="">
                    <Label
                      htmlFor="horizontal-firstname-Input"
                      className="col col-form-label"
                    >
                      <span className="text-danger">*</span>{" "}
                      {t("Select Branches")}
                    </Label>

                    <Select
                      value={values.ids}
                      isMulti={true}
                      onChange={selectedOption => {
                        if (
                          selectedOption?.find(option => option.value === "*")
                        ) {
                          setFieldValue("ids", branchListOptions)
                          setIsAllSelected(true)
                        } else {
                          setFieldValue("ids", selectedOption)
                          setIsAllSelected(
                            selectedOption.length === branchListOptions.length
                          )
                        }
                      }}
                      options={options}
                      placeholder={t("Select Branches")}
                      className={`select2-selection ${
                        touched.ids && errors.ids ? "danger_color_border" : ""
                      } `}
                      closeMenuOnSelect={false}
                    />
                    <TextError name="ids" />
                  </div>
                </Col>
                {/* <Col lg={2}>
                  <Label htmlFor="status" className="col col-form-label">
                    Status
                  </Label>
                  <div className="mt-1">
                    <Switch
                      onClickHandler={e => {
                        setFieldValue("status", !values.status)
                      }}
                      isChecked={values.status}
                    />
                  </div>
                </Col> */}
                <Col lg={12}>
                  <div className="form_field">
                    <Label
                      htmlFor="horizontal-firstname-Input"
                      className="col col-form-label"
                    >
                      {t("Select Opening Times")}
                    </Label>

                    <div className="table-responsive branch-opening-hours">
                      <Table bordered className="">
                        <thead>
                          <tr>
                            <th>{t("Day")}</th>
                            <th>{t("Opening Time")}</th>
                            <th>{t("Closing Time")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {values?.openingHours?.map((item, index) => (
                            <tr key={item.dayOfWeek}>
                              <td style={{ minWidth: 160 }}>
                                <div className="d-flex align-items-center mt-1">
                                  <Switch
                                    onClickHandler={e => {
                                      const updatedClosedDays = [...closedDays]
                                      updatedClosedDays[index] =
                                        !updatedClosedDays[index]
                                      setClosedDays(updatedClosedDays)

                                      const updatedOpeningHours = [
                                        ...values.openingHours,
                                      ]
                                      updatedOpeningHours[index].closed =
                                        updatedClosedDays[index]
                                      setFieldValue(
                                        `openingHours[${index}].closed`,
                                        updatedClosedDays[index]
                                      )
                                    }}
                                    isChecked={!closedDays[index]}
                                  />
                                  <span className="mx-2 pt-1">
                                    {t(item.dayOfWeek)}
                                  </span>
                                </div>
                              </td>
                              {!closedDays[index] && (
                                <td>
                                  <Field
                                    name={`openingHours[${index}].openingTime`}
                                  >
                                    {({ field }) => (
                                      <Flatpickr
                                        {...field}
                                        className="form-control d-block branch-opening-hours__time"
                                        value={field.value}
                                        placeholder="Select time"
                                        options={{
                                          enableTime: true,
                                          noCalendar: true,
                                          dateFormat: "H:i",
                                        }}
                                        onChange={([date]) => {
                                          const time = date
                                            .toTimeString()
                                            .slice(0, 5)
                                          setFieldValue(field.name, time)
                                        }}
                                      />
                                    )}
                                  </Field>
                                </td>
                              )}

                              {!closedDays[index] && (
                                <td>
                                  <Field
                                    name={`openingHours[${index}].closingTime`}
                                  >
                                    {({ field }) => (
                                      <Flatpickr
                                        {...field}
                                        className="form-control d-block branch-opening-hours__time"
                                        value={field.value}
                                        placeholder="Select time"
                                        options={{
                                          enableTime: true,
                                          noCalendar: true,
                                          dateFormat: "H:i",
                                        }}
                                        onChange={([date]) => {
                                          const time = date
                                            .toTimeString()
                                            .slice(0, 5)
                                          setFieldValue(field.name, time)
                                        }}
                                      />
                                    )}
                                  </Field>
                                </td>
                              )}
                              {closedDays[index] && (
                                <td colSpan={2}>
                                  <p className="text-center pt-1">
                                    {t("Closed")}
                                  </p>
                                </td>
                              )}
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </Col>

                <Col lg={12}>
                  <div className="d-flex justify-content-end mt-3">
                    <Button color="secondary" className="mx-3" onClick={toggle}>
                      {t("Close")}
                    </Button>
                    <Button color="success" type="submit" disabled={isLoading}>
                      {t("Save")}
                    </Button>
                  </div>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </ModalBody>
    </>
  )
}

export default UpdateOpeningHours
